import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import FacetContent from '../../lego/FacetContent';
import { useFacet } from '../../common';
const FacetButton = (props)=>{
    const { rootComponentProps, contentComponentProps, implementationSpecificProps } = useFacet(props);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({}, rootComponentProps, implementationSpecificProps), /*#__PURE__*/ React.createElement(FacetContent, contentComponentProps));
};
FacetButton.displayName = 'FacetButton';
export default FacetButton;
